export type PublicRuntimeConfig = {
  apiUrl: string;
  websocketUrl: string;
};

export const DEFAULT_PUBLIC_RUNTIME_CONFIG: PublicRuntimeConfig = {
  apiUrl: "http://localhost:4000",
  websocketUrl: "ws://localhost:4001",
};

export const RUNTIME_CONFIG_WINDOW_KEY = "__PRIMUS_RUNTIME_CONFIG__" as const;
